import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom'

import './style.css'
import Manufacture from './views/manufacture'
import Eminence from './views/eminence'
import Partners from './views/partners'
import CNC from './views/cnc'
import ArcticWhite from './views/arctic-white'
import Repair from './views/repair'
import Astorino from './views/astorino'
import WeldingMonitor from './views/welding-monitor'
import Goldenrod from './views/goldenrod'
import Service from './views/service'
import Contacts from './views/contacts'
import CustomRobotic from './views/custom-robotic'
import Main from './views/main'
import Company from './views/company'
import Team from './views/team'
import AllProjects from './views/all-projects'
import EducationCells from './views/education-cells'
import Printers from './views/printers'
import AboutWAAM from './views/about-waam'
import ExhibitionRobotic from './views/exhibition-robotic'
import Projects3D from './views/projects3d'
import RoboticWelding from './views/robotic-welding'
import Kolarc from './views/kolarc'
import Palletizing from './views/palletizing'
import Producing from './views/producing'
import KawasakiRobotics from './views/kawasaki-robotics'
import Materials from './views/materials'
import Founders from './views/founders'
import LeonidZhabrev from './views/leonid-zhabrev'
import IgorMushnikov from './views/igor-mushnikov'
import NotFound from './views/not-found'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={Manufacture} exact path="/manufacture" />
        <Route component={Eminence} exact path="/eminence" />
        <Route component={Partners} exact path="/partners" />
        <Route component={CNC} exact path="/cnc" />
        <Route component={ArcticWhite} exact path="/arctic-white" />
        <Route component={Repair} exact path="/repair" />
        <Route component={Astorino} exact path="/astorino" />
        <Route component={WeldingMonitor} exact path="/welding-monitor" />
        <Route component={Goldenrod} exact path="/goldenrod" />
        <Route component={Service} exact path="/service" />
        <Route component={Contacts} exact path="/contacts" />
        <Route component={CustomRobotic} exact path="/custom-robotic" />
        <Route component={Main} exact path="/" />
        <Route component={Company} exact path="/company" />
        <Route component={Team} exact path="/team" />
        <Route component={AllProjects} exact path="/all-projects" />
        <Route component={EducationCells} exact path="/education-cells" />
        <Route component={Printers} exact path="/printers" />
        <Route component={AboutWAAM} exact path="/about-waam" />
        <Route component={ExhibitionRobotic} exact path="/exhibition-robotic" />
        <Route component={Projects3D} exact path="/projects3d" />
        <Route component={RoboticWelding} exact path="/robotic-welding" />
        <Route component={Kolarc} exact path="/kolarc" />
        <Route component={Palletizing} exact path="/palletizing" />
        <Route component={Producing} exact path="/producing" />
        <Route component={KawasakiRobotics} exact path="/kawasaki-robotics" />
        <Route component={Materials} exact path="/materials" />
        <Route component={Founders} exact path="/founders" />
        <Route component={LeonidZhabrev} exact path="/leonid-zhabrev" />
        <Route component={IgorMushnikov} exact path="/igor-mushnikov" />
        <Route component={NotFound} path="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
